export default __webpack_public_path__ + "static/media/four.3b7a6b33.jpeg";